import { LS } from 'consts/localStorage';
import {
	addClass,
	generate6DigitUUID,
	generateBtnOnClickFnc,
	hasClass,
	readFromLs,
	removeClass,
	setCustomTagHTML,
} from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { scrollToLastMessage } from 'js/conversation';

import { formSelectData } from './formSelect.model';
import { FormSelectTemplate } from './formSelect.template';

export default class FormInput {
	constructor(props) {
		this.initData(props);
		this.initWrapper(props);
		this.initComponents();
	}

	initData(propData = {}) {
		this.data = formSelectData;
		this.setter(propData);
		this.data.id = propData.id || propData.message_id || `message-${generate6DigitUUID()}`;
	}

	initWrapper(props) {
		const wrapper = document.createElement('div');
		wrapper.innerHTML = FormSelectTemplate(props);
		this.html = wrapper;
	}

	generateDropdownOption(index, option, input, dropdown, highlightText, isMultiselectEnabled, attrId) {
		const optionElement = document.createElement('div');
		const engtCheckbox = document.createElement('input');
		const name = option[0].replaceAll(highlightText, `<b>${highlightText}</b>`);
		engtCheckbox.type = 'checkbox';
		engtCheckbox.id = option[1];
		engtCheckbox.name = name;
		engtCheckbox.setAttribute('data-attr-value', option[1]);
		const label = document.createElement('label');
		label.style = 'margin-left:14px';

		optionElement.setAttribute('aria-label', option[1]);
		optionElement.setAttribute('tabindex', index);

		label.innerHTML = name;
		if (isMultiselectEnabled) {
			const container = document.createElement('span');
			container.style = 'display:flex;align-items:center;';
			container.appendChild(engtCheckbox);
			container.appendChild(label);
			optionElement.appendChild(container);
		} else {
			optionElement.innerHTML = name;
		}
		optionElement.addEventListener('click', (e) => {
			input.value = e.target?.closest('div')?.innerText;
			if (!isMultiselectEnabled) {
				input.style = '';
				input.setAttribute(
					'data-attr-value',
					input.getAttribute('data-attr-value') && isMultiselectEnabled
						? `${input.getAttribute('data-attr-value')},${e.target.ariaLabel}`
						: e.target.ariaLabel
				);
			}
			const err = document.getElementById(`rud-error-${readFromLs(LS().RUD_NODE)}`);
			if (err) {
				err.classList.add('engt-hidden');
			}
			generateBtnOnClickFnc({ ...option, title: option[0] })();
			if (!isMultiselectEnabled) {
				dropdown.dispatchEvent(new CustomEvent('engt-option-selected', { bubbles: true }));
			}
		});
		dropdown.appendChild(optionElement);
	}

	mutiFormSelectUpdate(data, value, attrId) {
		Object.values(data).forEach((id) => {
			document.getElementById(id).checked = value;
		});
	}

	initComponents() {
		const { options, isMultiselect, attribute_id, attribute_type, id, inputWithSelect } = this.data;
		const optionsArray = Object.entries(JSON.parse(options));
		const isMultiselectEnabled = isMultiselect.toString() === 'true';
		const ref = this;
		const optionsDiv = document.createElement('div');
		const dropdown = document.createElement('div');
		let input = document.createElement('input');
		const dropdownSearchInput = document.createElement('input');
		dropdownSearchInput.type = 'text';
		dropdownSearchInput.className = 'engt-dropdown-search-input';
		const optionsContainer = document.createElement('div');
		optionsContainer.className = 'engt-dropdown-options-container';
		const arrow = document.createElement('div');
		const selectAll = document.createElement('button');
		const unSelectAll = document.createElement('button');
		const divider = document.createElement('span');

		let suppressingKeyboard = false;
		function freezeSearch() {
			suppressingKeyboard = true;
			dropdownSearchInput.readOnly = true;
			dropdownSearchInput.setAttribute('inputmode', 'none');
			if (document.activeElement === dropdownSearchInput) dropdownSearchInput.blur();
			setTimeout(() => {
				suppressingKeyboard = false;
			}, 0);
		}
		function enableSearch() {
			dropdownSearchInput.readOnly = false;
			dropdownSearchInput.removeAttribute('inputmode');
			dropdownSearchInput.focus();
		}

		if (isMultiselectEnabled) {
			input = document.createElement('div');
			input.className = 'multiselect';
			selectAll.className = 'selectOptions';
			selectAll.addEventListener('click', (event) => {
				event.stopPropagation();
				openDropdown();
				this.mutiFormSelectUpdate(JSON.parse(options), true);
			});
			unSelectAll.addEventListener('click', (event) => {
				event.stopPropagation();
				openDropdown();
				this.mutiFormSelectUpdate(JSON.parse(options), false);
			});
			unSelectAll.className = 'selectOptions-clear';
			selectAll.innerHTML = 'Select All';
			divider.innerHTML = '|';
			divider.style.paddingLeft = '4px';
			divider.style.paddingRight = '4px';
			unSelectAll.innerHTML = 'Clear All';
			input.appendChild(selectAll);
			input.appendChild(divider);
			input.appendChild(unSelectAll);
		}

		function getZIndexClass(isMultiselectEnabled) {
			return isMultiselectEnabled
				? 'engt-form-active-multiselect-dropdown-z-index'
				: 'engt-form-active-dropdown-z-index';
		}

		function addDropdownZIndexClass(isMultiselectEnabled) {
			const wrapperFormFieldElement = ref?.html?.closest('.engt-form-field-wrapper');
			if (wrapperFormFieldElement) {
				removeClass(wrapperFormFieldElement, 'engt-form-field-z-index');
				addClass(wrapperFormFieldElement, getZIndexClass(isMultiselectEnabled));
			}
		}

		function removeDropdownZIndexClass(isMultiselectEnabled) {
			const wrapperFormFieldElement = ref?.html?.closest('.engt-form-field-wrapper');
			if (wrapperFormFieldElement) {
				addClass(wrapperFormFieldElement, 'engt-form-field-z-index');
				removeClass(wrapperFormFieldElement, getZIndexClass(isMultiselectEnabled));
			}
		}

		function noop() {}
		let detachOutside = noop;
		let detachEsc = noop;

		function addOutsideClose() {
			if (detachOutside !== noop) return;
			const handler = (ev) => {
				if (!optionsDiv.contains(ev.target)) closeDropdown();
			};
			document.addEventListener('pointerdown', handler, true);
			detachOutside = () => {
				document.removeEventListener('pointerdown', handler, true);
				detachOutside = noop;
			};
		}

		function isOpen() {
			return arrow.className === 'up-arrow';
		}

		function addEscClose() {
			if (detachEsc !== noop) return;
			const handler = (ev) => {
				if (ev.key === 'Escape' && isOpen()) closeDropdown(true);
			};
			document.addEventListener('keydown', handler);
			detachEsc = () => {
				document.removeEventListener('keydown', handler);
				detachEsc = noop;
			};
		}

		function openDropdown() {
			if (arrow.className === 'up-arrow') return;
			addDropdownZIndexClass(isMultiselectEnabled);
			dropdown.style.display = 'block';
			input.style.borderBottomLeftRadius = '0px';
			input.style.borderBottomRightRadius = '0px';
			arrow.className = 'up-arrow';
			if (isMultiselectEnabled) {
				input.innerHTML = '';
				input.appendChild(selectAll);
				input.appendChild(divider);
				input.appendChild(unSelectAll);
			} else {
				dropdown.prepend(dropdownSearchInput);
				dropdown.appendChild(optionsContainer);
			}
			input.blur();
			addOutsideClose();
			addEscClose();
			scrollToLastMessage(false, 0);
		}

		function closeDropdown(forceClose = false) {
			if (isMultiselectEnabled) {
				let selectedCount = 0;
				document.querySelectorAll('.dropdown input[type=checkbox]').forEach((el) => {
					if (el.checked) {
						selectedCount++;
						input.innerHTML = `<div class='selectOptions-clear'>${selectedCount} ${
							selectedCount > 1 ? 'items' : 'item'
						} selected</div>`;
					}
				});
			}
			setTimeout(
				() => {
					input.style = '';
					dropdown.style.display = 'none';
					arrow.className = 'down-arrow';
					if (dropdownSearchInput && dropdown.contains(dropdownSearchInput)) {
						dropdown.removeChild(dropdownSearchInput);
					}
					removeDropdownZIndexClass(isMultiselectEnabled);
					detachOutside();
					detachEsc();
				},
				forceClose === true ? 0 : 300
			);
		}

		function toggleDropdown(e) {
			e?.stopPropagation?.();
			isOpen() ? closeDropdown(true) : openDropdown();
		}

		dropdown.addEventListener('engt-option-selected', () => closeDropdown(true));

		function onInputChange(e) {
			const text = e?.target?.value?.toLowerCase?.() || '';
			const filterOptions = (options, searchText) =>
				options.filter((option) => {
					const lowerSearchText = searchText?.toLowerCase();
					const optionKey = option?.[0]?.toLowerCase();
					const optionText = option.text?.toLowerCase();
					return (
						!lowerSearchText ||
						optionKey?.indexOf(lowerSearchText) > -1 ||
						optionText?.indexOf(lowerSearchText) > -1
					);
				});
			const renderOptions = (filteredOptions, container) => {
				container.innerHTML = '';
				filteredOptions.forEach((option, index) => {
					ref.generateDropdownOption(index, option, input, container, text, isMultiselectEnabled);
				});
			};
			const handleDropdownForMultiSelect = (filteredOptions) => {
				if (!filteredOptions.length || (!text.length && !e)) {
					closeDropdown(true);
				} else {
					openDropdown();
				}
			};
			const handleDropdownForSingleSelect = (filteredOptions, container) => {
				if (!filteredOptions.length) {
					container.innerHTML = '<div class="no-options">No result</div>';
				} else {
					openDropdown();
					setActiveElement(0);
				}
			};
			if (isMultiselectEnabled) {
				const filteredOptions = filterOptions(optionsArray, text);
				renderOptions(filteredOptions, dropdown);
				handleDropdownForMultiSelect(filteredOptions);
			} else {
				const filteredOptions = filterOptions(optionsArray, text);
				renderOptions(filteredOptions, optionsContainer);
				handleDropdownForSingleSelect(filteredOptions, optionsContainer);
			}
		}

		function onInputKeydown(e) {
			const keyCode = e.which ? e.which : e.keyCode;
			keyCode === 13 && !e.shiftKey && selectActiveOption();
			keyCode === 40 && highlightDown();
			keyCode === 38 && highlightUp();
		}

		function highlightDown() {
			const dropdownItems = isMultiselectEnabled ? dropdown.children : optionsContainer.children;
			for (let index = 0; index < dropdownItems.length; index++) {
				const element = dropdownItems[index];
				if (hasClass(element, 'active')) {
					element.className = '';
					const nextIndex = index < dropdownItems.length - 1 ? index + 1 : 0;
					const nextElement = dropdownItems[nextIndex];
					nextElement.className = 'active';
					nextElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
					return;
				}
			}
		}

		function highlightUp() {
			const dropdownItems = isMultiselectEnabled ? dropdown.children : optionsContainer.children;
			for (let index = 0; index < dropdownItems.length; index++) {
				const element = dropdownItems[index];
				if (hasClass(element, 'active')) {
					element.className = '';
					const prevIndex = index > 0 ? index - 1 : dropdownItems.length - 1;
					const prevElement = dropdownItems[prevIndex];
					prevElement.className = 'active';
					prevElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
					return;
				}
			}
		}

		function selectActiveOption() {
			const activeElement = isMultiselectEnabled
				? dropdown?.querySelector?.('.active')
				: optionsContainer?.querySelector?.('.active');
			if (activeElement) {
				activeElement.click();
				closeDropdown(true);
			}
		}

		function setActiveElement(index) {
			const dropdownItems = isMultiselectEnabled ? dropdown.children : optionsContainer.children;
			if (index >= 0 && index < dropdownItems.length) {
				dropdownItems[index].className = 'active';
			}
		}

		optionsDiv.className = 'engt-select-container';
		optionsDiv.classList.add(this.data.overrideOptions);
		optionsDiv.setAttribute('data-form-attrid', attribute_id);
		optionsDiv.setAttribute('data-form-type', attribute_type);
		dropdown.className = 'dropdown';
		input.id = attribute_id;
		input.setAttribute('data-form-id', `engt-select-container-${id}`);
		input.classList.add(this.data.overrideInputClass);
		arrow.className = 'down-arrow';
		const defaultPlaceholder = 'Select';
		const defaultPlaceholderSearch = 'Search';
		input.setAttribute(
			'placeholder',
			ENGT_CHAT.get('GENERIC_STRINGS')?.['SETTINGS.PLACEHOLDER.SELECT'] || defaultPlaceholder
		);
		dropdownSearchInput.setAttribute(
			'placeholder',
			ENGT_CHAT.get('GENERIC_STRINGS')?.['SETTINGS.PLACEHOLDER.SEARCH'] || defaultPlaceholderSearch
		);
		dropdownSearchInput.addEventListener('input', onInputChange);
		input.addEventListener('input', onInputChange);
		input.classList.add('engt-multiselect');
		input.classList.add(`engt-form-input-${attribute_id}`);

		if (isMultiselectEnabled) {
			optionsDiv.classList.add('engt-multiselect');
			input.addEventListener('keydown', onInputKeydown);
		} else {
			input.addEventListener('focus', () => {
				if (!isOpen()) openDropdown();
			});
			dropdownSearchInput.addEventListener('focusout', (e) => {
				if (suppressingKeyboard) return;
				const next = e.relatedTarget;
				if (!dropdown.contains(next) && next !== input) {
					closeDropdown();
				}
			});
			input.setAttribute('data-field-role', 'input');
			dropdownSearchInput.addEventListener('keydown', onInputKeydown);

			dropdownSearchInput.readOnly = true;
			dropdownSearchInput.setAttribute('inputmode', 'none');

			input.readOnly = true;
			input.setAttribute('inputmode', 'none');

			dropdown.addEventListener('touchmove', freezeSearch, { passive: true });
			dropdown.addEventListener('wheel', freezeSearch, { passive: true });

			function handleSearchActivation(e) {
				e.stopImmediatePropagation();
				enableSearch();
			}
			['touchstart', 'pointerdown', 'click'].forEach((evt) =>
				dropdownSearchInput.addEventListener(evt, handleSearchActivation)
			);
		}

		function onBarPointer(e) {
			if (dropdown.contains(e.target)) return;
			toggleDropdown(e);
		}

		optionsDiv.addEventListener('pointerdown', onBarPointer);
		optionsDiv.tabIndex = 0;
		optionsDiv.addEventListener('keydown', (e) => {
			if (e.key === 'Enter' || e.key === ' ') {
				e.preventDefault();
				toggleDropdown(e);
			}
		});

		optionsDiv.appendChild(input);
		optionsDiv.appendChild(arrow);
		optionsDiv.appendChild(dropdown);
		const errorContainer = document.createElement('div');
		errorContainer.id = `engt-select-error-${id}`;
		const errorElement = document.createElement('div');
		errorElement.className = 'engt-error';
		errorElement.id = `engt-error-${attribute_id}`;
		errorContainer.appendChild(errorElement);
		if (!inputWithSelect) {
			optionsDiv.appendChild(errorContainer);
		}
		onInputChange();
		closeDropdown(true);
		setCustomTagHTML(this.html.querySelector('form-select'), optionsDiv);
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
